/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Order Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
// @ts-ignore
import type { OrderCollectiveGetInfoResponse } from '../models';
// @ts-ignore
import type { OrderCollectiveResponse } from '../models';
// @ts-ignore
import type { OrderErrorConflict } from '../models';
// @ts-ignore
import type { OrderErrorNotFound } from '../models';
// @ts-ignore
import type { OrderInfoRequestHeader } from '../models';
// @ts-ignore
import type { OrderInfoRequestHeaderCreate } from '../models';
// @ts-ignore
import type { OrderSubOrderDeleteResponse } from '../models';
// @ts-ignore
import type { OrderSubOrderGetInfoResponse } from '../models';
// @ts-ignore
import type { OrderSubOrderRequest } from '../models';
// @ts-ignore
import type { OrderSubOrderResponse } from '../models';
// @ts-ignore
import type { OrderUpdateInfoSubOrderRequest } from '../models';
/**
 * OrderServiceCollectiveOrdersApi - axios parameter creator
 */
export const OrderServiceCollectiveOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates a collective order
         * @param {OrderInfoRequestHeaderCreate} orderInfoRequestHeaderCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollectiveOrder: async (orderInfoRequestHeaderCreate: OrderInfoRequestHeaderCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderInfoRequestHeaderCreate' is not null or undefined
            assertParamExists('createCollectiveOrder', 'orderInfoRequestHeaderCreate', orderInfoRequestHeaderCreate)
            const localVarPath = `/order/v1/collectiveOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderInfoRequestHeaderCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a subOrder for a collective order
         * @param {OrderSubOrderRequest} orderSubOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubOrder: async (orderSubOrderRequest: OrderSubOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderSubOrderRequest' is not null or undefined
            assertParamExists('createSubOrder', 'orderSubOrderRequest', orderSubOrderRequest)
            const localVarPath = `/order/v1/subOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderSubOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a sub Order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubOrder: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('deleteSubOrder', 'orderId', orderId)
            const localVarPath = `/order/v1/subOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the existing collective offset order {orderId}
         * @param {string} collectiveOrderId 
         * @param {string} [cursor] When collective order is returned with it\&#39;s sub orders, the cursor marks the last suborder. Use this to walk through paginated sub orders
         * @param {string} [limit] Determines number of sub orders to return per page for the given collective order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectiveOrder: async (collectiveOrderId: string, cursor?: string, limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectiveOrderId' is not null or undefined
            assertParamExists('getCollectiveOrder', 'collectiveOrderId', collectiveOrderId)
            const localVarPath = `/order/v1/collectiveOrder/{collectiveOrderId}`
                .replace(`{${"collectiveOrderId"}}`, encodeURIComponent(String(collectiveOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the existing suborder offset order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubOrder: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getSubOrder', 'orderId', orderId)
            const localVarPath = `/order/v1/subOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing collective offset order with given orderId
         * @param {string} collectiveOrderId 
         * @param {OrderInfoRequestHeader} orderInfoRequestHeader 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollectiveOrder: async (collectiveOrderId: string, orderInfoRequestHeader: OrderInfoRequestHeader, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'collectiveOrderId' is not null or undefined
            assertParamExists('updateCollectiveOrder', 'collectiveOrderId', collectiveOrderId)
            // verify required parameter 'orderInfoRequestHeader' is not null or undefined
            assertParamExists('updateCollectiveOrder', 'orderInfoRequestHeader', orderInfoRequestHeader)
            const localVarPath = `/order/v1/collectiveOrder/{collectiveOrderId}`
                .replace(`{${"collectiveOrderId"}}`, encodeURIComponent(String(collectiveOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderInfoRequestHeader, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a sub Order
         * @param {string} orderId 
         * @param {OrderUpdateInfoSubOrderRequest} [orderUpdateInfoSubOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubOrder: async (orderId: string, orderUpdateInfoSubOrderRequest?: OrderUpdateInfoSubOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateSubOrder', 'orderId', orderId)
            const localVarPath = `/order/v1/subOrder/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderUpdateInfoSubOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderServiceCollectiveOrdersApi - functional programming interface
 */
export const OrderServiceCollectiveOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderServiceCollectiveOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates a collective order
         * @param {OrderInfoRequestHeaderCreate} orderInfoRequestHeaderCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCollectiveOrder(orderInfoRequestHeaderCreate: OrderInfoRequestHeaderCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCollectiveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCollectiveOrder(orderInfoRequestHeaderCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.createCollectiveOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a subOrder for a collective order
         * @param {OrderSubOrderRequest} orderSubOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubOrder(orderSubOrderRequest: OrderSubOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderSubOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubOrder(orderSubOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.createSubOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a sub Order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubOrder(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderSubOrderDeleteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubOrder(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.deleteSubOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the existing collective offset order {orderId}
         * @param {string} collectiveOrderId 
         * @param {string} [cursor] When collective order is returned with it\&#39;s sub orders, the cursor marks the last suborder. Use this to walk through paginated sub orders
         * @param {string} [limit] Determines number of sub orders to return per page for the given collective order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCollectiveOrder(collectiveOrderId: string, cursor?: string, limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCollectiveGetInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCollectiveOrder(collectiveOrderId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.getCollectiveOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the existing suborder offset order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubOrder(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderSubOrderGetInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubOrder(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.getSubOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing collective offset order with given orderId
         * @param {string} collectiveOrderId 
         * @param {OrderInfoRequestHeader} orderInfoRequestHeader 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCollectiveOrder(collectiveOrderId: string, orderInfoRequestHeader: OrderInfoRequestHeader, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCollectiveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCollectiveOrder(collectiveOrderId, orderInfoRequestHeader, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.updateCollectiveOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a sub Order
         * @param {string} orderId 
         * @param {OrderUpdateInfoSubOrderRequest} [orderUpdateInfoSubOrderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubOrder(orderId: string, orderUpdateInfoSubOrderRequest?: OrderUpdateInfoSubOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderSubOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubOrder(orderId, orderUpdateInfoSubOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderServiceCollectiveOrdersApi.updateSubOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderServiceCollectiveOrdersApi - factory interface
 */
export const OrderServiceCollectiveOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderServiceCollectiveOrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates a collective order
         * @param {OrderServiceCollectiveOrdersApiCreateCollectiveOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCollectiveOrder(requestParameters: OrderServiceCollectiveOrdersApiCreateCollectiveOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderCollectiveResponse> {
            return localVarFp.createCollectiveOrder(requestParameters.orderInfoRequestHeaderCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a subOrder for a collective order
         * @param {OrderServiceCollectiveOrdersApiCreateSubOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubOrder(requestParameters: OrderServiceCollectiveOrdersApiCreateSubOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderSubOrderResponse> {
            return localVarFp.createSubOrder(requestParameters.orderSubOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a sub Order
         * @param {OrderServiceCollectiveOrdersApiDeleteSubOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubOrder(requestParameters: OrderServiceCollectiveOrdersApiDeleteSubOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderSubOrderDeleteResponse> {
            return localVarFp.deleteSubOrder(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the existing collective offset order {orderId}
         * @param {OrderServiceCollectiveOrdersApiGetCollectiveOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCollectiveOrder(requestParameters: OrderServiceCollectiveOrdersApiGetCollectiveOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderCollectiveGetInfoResponse> {
            return localVarFp.getCollectiveOrder(requestParameters.collectiveOrderId, requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the existing suborder offset order
         * @param {OrderServiceCollectiveOrdersApiGetSubOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubOrder(requestParameters: OrderServiceCollectiveOrdersApiGetSubOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderSubOrderGetInfoResponse> {
            return localVarFp.getSubOrder(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing collective offset order with given orderId
         * @param {OrderServiceCollectiveOrdersApiUpdateCollectiveOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCollectiveOrder(requestParameters: OrderServiceCollectiveOrdersApiUpdateCollectiveOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderCollectiveResponse> {
            return localVarFp.updateCollectiveOrder(requestParameters.collectiveOrderId, requestParameters.orderInfoRequestHeader, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a sub Order
         * @param {OrderServiceCollectiveOrdersApiUpdateSubOrderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubOrder(requestParameters: OrderServiceCollectiveOrdersApiUpdateSubOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrderSubOrderResponse> {
            return localVarFp.updateSubOrder(requestParameters.orderId, requestParameters.orderUpdateInfoSubOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createCollectiveOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiCreateCollectiveOrderRequest {
    readonly orderInfoRequestHeaderCreate: OrderInfoRequestHeaderCreate
}

/**
 * Request parameters for createSubOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiCreateSubOrderRequest {
    readonly orderSubOrderRequest: OrderSubOrderRequest
}

/**
 * Request parameters for deleteSubOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiDeleteSubOrderRequest {
    readonly orderId: string
}

/**
 * Request parameters for getCollectiveOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiGetCollectiveOrderRequest {
    readonly collectiveOrderId: string

    /**
     * When collective order is returned with it\&#39;s sub orders, the cursor marks the last suborder. Use this to walk through paginated sub orders
     */
    readonly cursor?: string

    /**
     * Determines number of sub orders to return per page for the given collective order
     */
    readonly limit?: string
}

/**
 * Request parameters for getSubOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiGetSubOrderRequest {
    readonly orderId: string
}

/**
 * Request parameters for updateCollectiveOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiUpdateCollectiveOrderRequest {
    readonly collectiveOrderId: string

    readonly orderInfoRequestHeader: OrderInfoRequestHeader
}

/**
 * Request parameters for updateSubOrder operation in OrderServiceCollectiveOrdersApi.
 */
export interface OrderServiceCollectiveOrdersApiUpdateSubOrderRequest {
    readonly orderId: string

    readonly orderUpdateInfoSubOrderRequest?: OrderUpdateInfoSubOrderRequest
}

/**
 * OrderServiceCollectiveOrdersApi - object-oriented interface
 */
export class OrderServiceCollectiveOrdersApi extends BaseAPI {
    /**
     * 
     * @summary Creates a collective order
     * @param {OrderServiceCollectiveOrdersApiCreateCollectiveOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCollectiveOrder(requestParameters: OrderServiceCollectiveOrdersApiCreateCollectiveOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).createCollectiveOrder(requestParameters.orderInfoRequestHeaderCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a subOrder for a collective order
     * @param {OrderServiceCollectiveOrdersApiCreateSubOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createSubOrder(requestParameters: OrderServiceCollectiveOrdersApiCreateSubOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).createSubOrder(requestParameters.orderSubOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a sub Order
     * @param {OrderServiceCollectiveOrdersApiDeleteSubOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteSubOrder(requestParameters: OrderServiceCollectiveOrdersApiDeleteSubOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).deleteSubOrder(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the existing collective offset order {orderId}
     * @param {OrderServiceCollectiveOrdersApiGetCollectiveOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCollectiveOrder(requestParameters: OrderServiceCollectiveOrdersApiGetCollectiveOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).getCollectiveOrder(requestParameters.collectiveOrderId, requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the existing suborder offset order
     * @param {OrderServiceCollectiveOrdersApiGetSubOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSubOrder(requestParameters: OrderServiceCollectiveOrdersApiGetSubOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).getSubOrder(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing collective offset order with given orderId
     * @param {OrderServiceCollectiveOrdersApiUpdateCollectiveOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCollectiveOrder(requestParameters: OrderServiceCollectiveOrdersApiUpdateCollectiveOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).updateCollectiveOrder(requestParameters.collectiveOrderId, requestParameters.orderInfoRequestHeader, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a sub Order
     * @param {OrderServiceCollectiveOrdersApiUpdateSubOrderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateSubOrder(requestParameters: OrderServiceCollectiveOrdersApiUpdateSubOrderRequest, options?: RawAxiosRequestConfig) {
        return OrderServiceCollectiveOrdersApiFp(this.configuration).updateSubOrder(requestParameters.orderId, requestParameters.orderUpdateInfoSubOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

